import { type } from 'arktype';

export const timetrackingPersonQuerySchema = type({
  'personId?': 'string',
});

export type TimetrackingPersonQuery = typeof timetrackingPersonQuerySchema.t;

export const createTimetrackingPersonSchema = type({
  personId: 'string',
});

export type CreateTimetrackingPerson = typeof createTimetrackingPersonSchema.t;

export interface TimetrackingPerson {
  id: string;
  personId: string;
  createdAt: string;
  updatedAt: string;
}
